module.exports = __webpack_public_path__ + "fonts/STKBureauSerif-Light.5bf88b4fe7a9156e404a3d37969afb5a.woff";